import classNames from 'classnames';
import { useMemo } from 'react';

import { TableContainer, Table as MuiTable } from '@mui/material';

export interface TableProps {
  className?: string;
  layout?: 'auto' | 'fixed';
  border?: 'collapse' | 'separate';
  fullWidth?: boolean;
  size?: 'small' | 'medium' | 'xs';
}

/**
 * A table component which consists of multiple separated subcomponents to build a table -
 * Subcomponents are `TableBody`, `TableRow`, `TableCell`, `TableHead`, `TableHeadRow`, `TableHeadCell`
 */
export function Table(props: React.PropsWithChildren<TableProps>) {
  const { className, layout = 'auto', border = 'collapse', fullWidth = true, size = 'medium' } = props;

  return (
    <TableContainer
      className={classNames(
        'border border-border w-full',
        { 'table-auto': layout === 'auto', 'table-fixed': layout === 'fixed' },
        { 'border-collapse': border === 'collapse', 'border-separate': border === 'separate' },
        { 'min-w-full': fullWidth },
        className,
      )}
    >
      <MuiTable>{props.children}</MuiTable>
    </TableContainer>
  );
}

export default Table;
